import React, { Component } from 'react'

import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class DebtsTooltip extends Component {
    render() {
        return (
            <div className={'tooltip-debts'}>
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.debtsTooltipMain`}
                    values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                />
                <div className={cx('tooltip-debts-icon', 'na')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.debtsNo`} />
                </div>
                <div className={cx('tooltip-debts-icon', 'debt-present')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.debtsActive`} />
                </div>
                <div className={cx('tooltip-debts-icon', 'debt-past')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.debtsHistorical`} />
                </div>
                <div>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.debtsFooterText1`}
                        values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                    />
                </div>
                <div>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.debtsFooterText2`}
                        values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                    />
                </div>
            </div>
        )
    }
}
